import {
  SupportedMediaMime,
  SupportedMediaType,
} from "../../apollo/graphql.generated";

export const mimeFromType: Record<string, string> = {
  "audio/mpeg": SupportedMediaMime.MP3,
  "audio/wav": SupportedMediaMime.WAV,
  "image/png": SupportedMediaMime.PNG,
  "image/webp": SupportedMediaMime.WEBP,
  "image/gif": SupportedMediaMime.GIF,
  "image/jpeg": SupportedMediaMime.JPEG,
  "image/jpg": SupportedMediaMime.JPEG,
  "video/webm": SupportedMediaMime.WEBM,
  "video/mp4": SupportedMediaMime.MP4,
};

export const fileTypeFromExtension = (filepath: string) => {
  // TODO: use library for this, was facing weird import errors (mismatch with version of "path" library?)
  if (!filepath) {
    return "unknown";
  }
  const splits = filepath.split(".");
  if (splits.length < 2) {
    return "unknown";
  }
  const ext = splits.pop();
  switch (ext) {
    case "wav":
      return "audio/wav";
    case "mpeg":
      return "audio/mpeg";
    case "png":
      return "image/png";
    case "webp":
      return "image/webp";
    case "gif":
      return "image/gif";
    case "jpeg":
    case "jpg":
      return "image/jpeg";
    case "webm":
      return "video/webm";
    case "mp4":
      return "video/mp4";
    default:
      return "unknown";
  }
};

export const formatsByType: Record<SupportedMediaType, SupportedMediaMime[]> = {
  [SupportedMediaType.IMAGE]: [
    SupportedMediaMime.JPEG,
    SupportedMediaMime.PNG,
    SupportedMediaMime.WEBP,
    SupportedMediaMime.GIF,
  ],
  [SupportedMediaType.AUDIO]: [SupportedMediaMime.MP3, SupportedMediaMime.WAV],
  [SupportedMediaType.VIDEO]: [SupportedMediaMime.MP4, SupportedMediaMime.WEBM],
};

export const sizeMbByType: Record<SupportedMediaType, number> = {
  [SupportedMediaType.IMAGE]: 25,
  [SupportedMediaType.AUDIO]: 250,
  [SupportedMediaType.VIDEO]: 50,
};

export const increasedSizeMbByType: Record<SupportedMediaType, number> = {
  [SupportedMediaType.IMAGE]: 2000,
  [SupportedMediaType.AUDIO]: 2000,
  [SupportedMediaType.VIDEO]: 2000,
};

export const typeFromMime: Record<string, SupportedMediaType> = {
  "audio/mpeg": SupportedMediaType.AUDIO,
  "audio/wav": SupportedMediaType.AUDIO,
  "image/png": SupportedMediaType.IMAGE,
  "image/gif": SupportedMediaType.IMAGE,
  "image/jpeg": SupportedMediaType.IMAGE,
  "image/jpg": SupportedMediaType.IMAGE,
  "image/webp": SupportedMediaType.IMAGE,
  "video/webm": SupportedMediaType.VIDEO,
  "video/mp4": SupportedMediaType.VIDEO,
};
